import styled from "styled-components";

export const RabbitFestivalCompetitionsListWrapper = styled.div`
  padding: 0 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RabbitFestivalCompetitionsItem = styled.div`
  width: 100%;
  position: relative;
  border-radius: 8px;

  > img {
    width: 100%;
    height: 210px;
    border-radius: 8px;
    object-fit: cover;
  }

  > .back {
    width: 100%;
    height: 210px;
    border-radius: 8px;
    top: 0;
    position: absolute;
    background: linear-gradient(
      180deg,
      rgba(18, 18, 18, 0) 51.08%,
      #121212 85.49%
    );
  }
`;

export const RabbitFestivalCompetitionsItemText = styled.div`
  position: absolute;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 2px;
  bottom: 20px;
  left: 12px;

  > .title {
    font-weight: 700;
    font-size: 18px;
  }

  > .subTitle {
    font-weight: 500;
    font-size: 12px;
  }
`;
